import { BoostBrandFactory } from '../types';

export const getCarrotBoostBrand: BoostBrandFactory = (theme) => ({
	title: 'Carrot Chat',
	avatarUrl: '/carrot-chat-avatar.png',
	styling: {
		avatarUrl: '/carrot-chat-avatar.png',
		fontFamily: 'Lato, sans-serif',
		primaryColor: theme.palette.primary.main,
		pace: 'fast',
		position: {
			zIndex: 9999999999999,
		},
		buttons: {
			backgroundColor: theme.palette.secondary.main,
			textColor: '#fff',
		},
		composer: {
			hide: false,
		},
		menuIconName: 'question-circle',
	},
});
